import React, { memo, useContext, useEffect, useState } from 'react';
import { 
    TableCell,
    TableRow,
} from '@material-ui/core';
import moment from 'moment';
import SVG from "react-inlinesvg";
import { defaultPath } from '../../../../../tickets/routes';
import { useTranslation } from 'react-i18next';
import styles from './notificationMenuItem.module.scss';
import { historySVG } from '../../../../../shared/helpers/icons';
import { cutMessage, eventSVG, formatWord, getNotificationColor, getNotificationSvgColor, removeHtml, removeStyle, socialTypeSVG } from '../../../../helpers/notifications/notifications';
import ChannelsDataContext from '../../../../../app/contexts/ChannelsContext/ChannelsDataContext';

const NotificationMenuItem = ({
    notification,
    history,
    handleCloseNotificationMenu,
}) => {
    const [messageSocialInc, setMessageSocialInc] = useState([]);
    const [username, setUsername] = useState([])

    const { getChannelColorIcon } = useContext(ChannelsDataContext);

    const handleClickNotification = (notification) => {
        notification.read = true;
        handleCloseNotificationMenu()
        notification.name === "social.incoming" ?
            history.push(`${defaultPath}/${notification.publicationId}`)
            :
            history.push(`${defaultPath}/${notification._id}`);
    }
    const { t } = useTranslation(['notification', 'tickets', 'social']);

    const formatMessageSocialInc = (notification) => {
        const formattedName = '@' + formatWord(notification.senderDisplayName)
        switch (notification.socialType) {
            case "comment":{
                return [`${formattedName}`, `${t("social:has_commented")}`]
            }
            case "reaction":{
                return [`${formattedName}`, `${t("social:has_reacted")}`]
            }
            case "mention":{
                return [`${formattedName}`, `${t("social:has_mentioned")}`]
            }
            case "feed":{
                return [`${formattedName}`, `${t("social:has_published")}`]
            }
            default:
                return t("notification:new_notification");
        }
    }

    const formatMessage = (notification) => {
        switch (notification.name) {
            case "tasks.created":{
                return `${notification.userDisplayName} ${t("notification:has_created_task")} ${notification.taskId}, ${t("notification:in_area")} ${notification.taskProject}`
            }
            case "tasks.comment":{
                let message = removeStyle(notification.message);
                message = removeHtml(message)
                return cutMessage(message);
            }
            case "tasks.status.updated":{
                return `${t("notification:status_changed_from")} ${notification.prevStatus} ${t("notification:status_changed_to")} ${notification.nextStatus}`
            }
            case "tasks.updated":{
                return `${notification.userName} ${t("notification:has_updated")}`
            }
            case "tasks.status.resolved":{
                if (notification.massiveClose){
                    return t("notification:has_been_closed_massively")
                } else {
                    return `${t("notification:ticket")} ${notification.taskId} ${t("notification:has_been_closed")}`
                }
            }
            case "tasks.status.expired":{
                return `${t("notification:workflow_ticket")} ${notification.taskWorkflow} ${t("notification:has_expired")} ${notification.ruleExecuted}`
            }
            case "tasks.assigned":{
                return `${notification.userName}, ${t("notification:tasks_assigned")} ${notification.taskId}`
            }
            default:
                return t("notification:new_notification");
        }
    }

    useEffect(() => {
        if(notification && notification.name === "social.incoming") {
            const message = formatMessageSocialInc(notification);
            if(typeof message !== 'string') {
                setUsername(message[0])
                setMessageSocialInc(message[1])
            }
            else {
                setMessageSocialInc(message)
            }
        }
    }, [notification])

    return (
        <TableRow
            key={
                notification.name === "social.incoming" ?
                    notification.publicationId
                    :
                    notification._id
            }
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            onClick={() => handleClickNotification(notification)}
            className={styles.notificationContainer}
            hover
        >
            <TableCell align="left">
            {notification && notification.name !== ("tasks.comment" || "tasks.status.updated" || "tasks.status.resolved") && notification.name !== "social.incoming" ?
                <div className={styles.taskIdContainer} style={{"--backgroundColor":getNotificationColor(notification.name)}}>
                    <SVG style ={{"--svgFill":getNotificationSvgColor(notification.name)}} src={eventSVG(notification.name)}/>
                </div>
                : 
                <div className ={styles.sourceContainer}>
                    <div className={styles.sourceIcons}>
                        <div>
                            <SVG 
                                className={styles.sourceIcon} 
                                src={getChannelColorIcon(
                                    notification.name === "social.incoming" ?
                                        notification.socialChannel
                                        :
                                        notification.taskSource
                                    )
                                }
                            />
                        </div>
                        <div>
                            {notification.name === "social.incoming" ?
                                <SVG className={styles.interactionType} src={socialTypeSVG(notification.socialType)}/>
                                :
                                <SVG className={styles.interactionType} src={eventSVG(notification.name)}/>
                            }
                        </div>
                    </div>
                </div>
            }               
            </TableCell>
            <TableCell align="left">
                {notification && notification.name === "social.incoming"?
                    <>
                        <div className={styles.centerNotification}/>
                        <span className={notification && notification.read ? `${styles.message} ${styles.read}` : `${styles.message} ${styles.unread}`}>
                            {username &&
                                <span className={notification && notification.read ? `${styles.username} ${styles.read}` : `${styles.username} ${styles.unread}`}>{username}</span>
                            }
                            &nbsp;{messageSocialInc}
                        </span>
                    </>
                    :
                    <>
                        {notification && notification.name !== ("tasks.created" || "tasks.assigned")?
                            <div className={styles.taskId}> {t('notification:in_taskId')} {notification.taskId}</div>
                            :
                            <div className={styles.taskId}>{t('tickets:new')}</div>
                        }
                        <div className={notification && notification.read ? `${styles.message} ${styles.read}` : `${styles.message} ${styles.unread}`}>
                            {formatMessage(notification)}
                        </div>
                    </>
                }
                <div className={styles.dateContainer}>
                    <div>
                        <SVG src={historySVG}/>
                    </div>
                    <div className={styles.dateText}>
                        {notification && notification.date && moment(notification.date).format('DD/MM/YYYY, HH:mm')}
                    </div>
                    
                </div>
            </TableCell>
            <TableCell align="left">
                { notification.read ?
                    <span></span>
                    :
                    <span className={styles.readPoint}></span>
                }
            </TableCell>
        </TableRow>
    )
}

export default memo(NotificationMenuItem);